import img1 from "../../assets/images/ecommerce/jpg/1.jpg";
import img2 from "../../assets/images/ecommerce/jpg/1.jpg";
import img3 from "../../assets/images/ecommerce/jpg/1.jpg";
import img4 from "../../assets/images/ecommerce/jpg/1.jpg";
import img5 from "../../assets/images/ecommerce/jpg/1.jpg";
import img6 from "../../assets/images/ecommerce/jpg/1.jpg";
import img7 from "../../assets/images/ecommerce/jpg/1.jpg";
import img8 from "../../assets/images/ecommerce/jpg/1.jpg";
import img9 from "../../assets/images/ecommerce/jpg/1.jpg";
import img10 from "../../assets/images/ecommerce/jpg/1.jpg";
import img11 from "../../assets/images/ecommerce/jpg/1.jpg";
import img12 from "../../assets/images/ecommerce/jpg/1.jpg";
export const ItemData1 = [
   {
      id: '1',
      preview: img1,
      title: 'Dapzem & Co',
      oldpr: '$229',
      newpr: '$1,799',
      offerprice: '$229',
      quantity: 1,
      size: 'large'
   },
   {
      id: '2',
      preview: img2,
      title: 'Denim Winjo',
      oldpr: '$599',
      newpr: '$2,499',
      offerprice: '$599',
      quantity: 2,
      size: 'medium'
   },
   {
      id: '3',
      preview: img3,
      title: 'Jimmy Lolfiger',
      oldpr: '$1,199',
      newpr: '$3,299',
      offerprice: '$1,199',
      quantity: 3,
      size: 'large'
   },
   {
      id: '4',
      preview: img4,
      title: 'Bluberry Co.In',
      oldpr: '$349',
      newpr: '$1,299',
      offerprice: '$349',
      quantity: 4,
      size: 'medium'
   },
   {
      id: '5',
      preview: img5,
      title: 'Aus Polo Assn',
      oldpr: '$1,899',
      newpr: '$3,799',
      offerprice: '$1,899',
      quantity: 5,
      size: 'large'
   },

];
export const Maindata = [
   {
      id: '1',
      preview: img1,
      title: 'Dapzem & Co',
      description: 'Branded hoodie ethnic style',
      oldpr: '$229',
      newpr: '$1,799',
      offerprice: '$229',
      quantity: 1,
      images: [
         { 'img': img1 },
         { 'img': img1 },
         { 'img': img1 }],
      size: 'large'
   },
   {
      id: '2',
      preview: img2,
      title: 'Denim Winjo',
      description: 'Vintage pure leather Jacket',
      oldpr: '$599',
      newpr: '$2,499',
      offerprice: '$599',
      quantity: 2,
      images: [
         { 'img': img2 },
         { 'img': img2 },
         { 'img': img2 }],
      ribbon: '',
      size: 'medium'
   },
   {
      id: '3',
      preview: img3,
      title: 'Jimmy Lolfiger',
      description: 'Unisex jacket for men & women',
      oldpr: '$1,199',
      newpr: '$3,299',
      offerprice: '$1,199',
      quantity: 1,
      images: [
         { 'img': img3 },
         { 'img': img3 },
         { 'img': img3 }],
      ribbon: '',
      size: 'small'
   },
   {
      id: '4',
      preview: img4,
      title: 'Bluberry Co.In',
      description: 'Full sleeve white hoodie',
      oldpr: '$349',
      newpr: '$1,299',
      offerprice: '$349',
      quantity: 1,
      images: [
         { "img": img4 },
         { "img": img4 },
         { "img": img4 },],
      ribbon: '',
      size: 'large'
   },
   {
      id: '5',
      preview: img5,
      title: 'Aus Polo Assn',
      description: 'Snow jacket with low pockets',
      oldpr: '$1,899',
      newpr: '$3,799',
      offerprice: '$1,899',
      quantity: 1,
      images: [
         { 'img': img5 },
         { 'img': img5 },
         { 'img': img5 }],
      size: 'large'
   },
   {
      id: '6',
      preview: img6,
      title: 'BMW',
      description: 'Ethnic wear jackets form BMW',
      oldpr: '$1,499',
      newpr: '$2,499',
      offerprice: '$1,499',
      quantity: 1,
      images: [
         { 'img': img6 },
         { 'img': img6 },
         { 'img': img6 }],
      size: 'medium'
   },
   {
      id: '7',
      preview: img7,
      title: 'Denim Corporation',
      description: 'Flap pockets denim jackets for men',
      oldpr: '$299',
      newpr: '$399',
      offerprice: '$299',
      quantity: 1,
      images: [
         { 'img': img7 },
         { 'img': img7 },
         { 'img': img7 }],
      ribbon: '',
      size: 'small'
   },
   {
      id: '8',
      preview: img8,
      title: 'Pufa',
      description: 'Ergonic designed full sleeve coat',
      oldpr: '$2,399',
      newpr: '$5,699',
      offerprice: '$2,399',
      quantity: 1,
      images: [
         { 'img': img8 },
         { 'img': img8 },
         { 'img': img8 }],
      ribbon: '',
      size: 'large'
   },
   {
      id: '9',
      preview: img9,
      title: 'Louie Phillippe',
      description: 'Ergonic green colored full sleeve jacket',
      oldpr: '$1,899',
      newpr: '$3,299',
      offerprice: '$1,899',
      quantity: 1,
      images: [
         { 'img': img9 },
         { 'img': img9 },
         { 'img': img9 }],
      size: 'large'
   },

   {
      id: '10',
      preview: img10,
      title: 'Denim Corp',
      description: 'beautiful brown colored snow jacket',
      oldpr: '$2,499',
      newpr: '$4,999',
      offerprice: '$499',
      quantity: 1,
      images: [
         { 'img': img10 },
         { 'img': img10 },
         { 'img': img10 }],
      size: 'medium'
   },

   {
      id: '11',
      preview: img11,
      title: 'Garage & Co',
      description: 'Full sleeve sweat shirt',
      oldpr: '$249',
      newpr: '$1,299',
      offerprice: '$249',
      quantity: 1,
      images: [
         { 'img': img11 },
         { 'img': img11 },
         { 'img': img11 }],
      size: 'large'
   },
   {
      id: '12',
      preview: img12,
      title: 'Blueberry & Co',
      description: 'Light colored sweater form blueberry',
      oldpr: '$499',
      newpr: '$799',
      offerprice: '$499',
      quantity: 1,
      images: [
         { 'img': img12 },
         { 'img': img12 },
         { 'img': img12 }],
      size: 'medium'
   },
];
